import { render } from "./quote_button.vue?vue&type=template&id=5e7ff388"
import script from "./quote_button.js?vue&type=script&lang=js"
export * from "./quote_button.js?vue&type=script&lang=js"

import "./quote_button.vue?vue&type=style&index=0&id=5e7ff388&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__